import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { getMediumRole } from "../../../../utils/utils";
import { useNavigate, useSearchParams } from "react-router-dom";
import { filterList, bulkListApproval, filterListpendin } from "../data";
import Checkbox from "../../Subcomponents/checkbox";
import Button from "../../../../components/button";
import ToggleTestUser from "../../Subcomponents/toogletestuser";
import CopyComponent from "../../../../components/copyComponent";
import Pagination from "../../../../components/tablePagination";
import Search from "../../../../components/search";
import { setPathArray, setUnverifiedEmailsPage, setUnverifiedEmailsrowsPerPage } from "../../../../reducer/adminSlice";
import { toast } from "react-toastify";
// import { setAllUnverifiedEmailsCount } from "../../../../reducer/adminSlice";
import FraudSignalBadge from "../../../../components/fraudsignalbadge";
import MediumInfoPanel from "../MediumInfoPanel";


export default function UnverifiedEmails(props) {
  const { unverifiedEmails, updateUser, onClickHandler, filterListMediums, bulkActions, resendUnverifiedEmail, getPaginationData, unverifiedEmailsPage,
    unverifiedEmailsrowsPerPage, setFilterValues,
    setSearchValues,
    searchValue,filterReset,
    filterValues,  setOptionsList,
    optionsList,
    operatorList,
    setOperatorList,
    showOprater,
    setShowOprater,
    setFilterOprater,
    filterOprater,setFilterValueOptions, filterValueOptions,isSearching,
    checked, setChecked, selected, setSelected } = props;
    const {
      allUnverifiedEmailsCount,
      allUnverifiedEmailsCountMediumPage

    } = useSelector((state) => state.users);
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [panelMedium, setPanelMedium] = useState(null);
  const [panelDetails, setPanelDetails] = useState(null);
  const [panelLoading, setPanelLoading] = useState(false);

  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
    return name.substring(0, 2).toUpperCase();
  };
  const getAvatarStyle = (name) => {
    const palettes = [
      { background: '#f5e6d8', color: '#b87040' },
      { background: '#faf0e8', color: '#c07838' },
      { background: '#eeddd0', color: '#a86030' },
      { background: '#f7ece0', color: '#d5a67b' },
      { background: '#f0e0cc', color: '#b87848' },
    ];
    const idx = name ? name.charCodeAt(0) % palettes.length : 0;
    return palettes[idx];
  };

  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');

  useEffect(()=>{
    if (page !== null) {

      dispatch(setUnverifiedEmailsPage(page));
    }
    if (rowperpage !== null) {
      dispatch(setUnverifiedEmailsrowsPerPage(rowperpage));
    }
  },[])
  let info = JSON.parse(localStorage.getItem('pagination'))


  const navigateUser = (id) => {
    window.renderFirst = false;
    dispatch(setPathArray(id.id));
    navigate(`/profile-view/${id.id}?view=5&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const navigateEdit = (e, id) => {
    window.renderFirst = false
    if (e.target.className == "capitalize") {
      navigate(`/profile-edit/${id.id}?view=5&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
    } else {
    }
  };
  const handleEditClick = (e, id) => {
    e.stopPropagation();
    window.renderFirst = false;
    navigate(`/profile-edit/${id.id}?view=5&search=${filterValues}&searchName=${Object.values(searchValue)}&page=${info.page}&rowperpage=${info.rowsPerPage}&searchOprator=${showOprater}&searchFilterOprater=${filterOprater}`);
  };
  const checkBoxChangeHandler = (e) => {
    setChecked(e.target.checked);
    if (e.target.checked) {
      let result = unverifiedEmails.map((a) => a.id);
      setSelected(result);
    } else {
      setSelected([]);
    }
  };

  // const getPaginationData = (item) => {
  //   console.log('paginationdata',item.from);
  //   getFromToData(item);
  //  };

  const handleScreenNameClick = function(e, item) {
    e.stopPropagation();
    setPanelMedium(item);
    setPanelDetails({ general: { phone: item.phone || '', whatsapp: item.whatsapp || '', country: item.country || '', timezone: item.timezone || '', timezone_label: item.timezone_label || '', created_at: item.created_at || '' } });
    setPanelLoading(false);
  };

  var panelActions = panelMedium ? [
    { label: 'Approve', variant: 'success', onClick: function(e) { e.stopPropagation(); updateUser(panelMedium, 5, 'unverifiedemails', 'unverifiedemails'); setPanelMedium(null); } },
    { label: 'View Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.open('/public-view/' + panelMedium.id, '_blank'); setPanelMedium(null); } },
    { label: 'Edit Profile', variant: 'primary', onClick: function(e) { e.stopPropagation(); window.renderFirst = false; navigate('/profile-edit/' + panelMedium.id + '?view=5&search=' + filterValues + '&searchName=' + Object.values(searchValue) + '&page=' + info.page + '&rowperpage=' + info.rowsPerPage + '&searchOprator=' + showOprater + '&searchFilterOprater=' + filterOprater); setPanelMedium(null); } },
    { label: 'Send Activation Email', variant: 'default', onClick: function(e) { e.stopPropagation(); resendUnverifiedEmail(e, panelMedium.id); } },
    { label: 'Delete', variant: 'danger', onClick: function(e) { e.stopPropagation(); updateUser(panelMedium, 3, 'delete', 'unverifiedemails'); setPanelMedium(null); } },
  ] : [];

  return (
    <>
      <div className="table-box-medium table-container">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th>
                <input
                  onChange={(e) => checkBoxChangeHandler(e)}
                  type="checkbox"
                  id="one"
                />
                <label htmlFor="one"></label>
                &nbsp;
              </th>
              <th>Screen Name & Email</th>
              <th>Test User</th>
              <th>Starter Referral Code</th>
              {/* <th>Total Starter Referrals</th> */}
              <th>Created</th>
              <th>Approved Role</th>
              {/* <th>Activation email</th> */}
              <th>Fraud Risk</th>
              <th>Action</th>
              {/* <th>Action</th> */}
            </tr>
            {isSearching ? (
              <tr>
              <td colSpan="12" className="text-center py-4">
                <div className="custom-loader">
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                  <div className="loader-dot"></div>
                </div>
                <div className="loader-text mt-2">Loading mediums...</div>
              </td>
            </tr>
              )
            :unverifiedEmails.length > 0 ? (
              unverifiedEmails.map((user) => (
                <tr className="innr">
                 <td>
                    <Checkbox
                      medium={user}
                      status={checked}
                      selected={selected}
                      setSelected={setSelected}
                    />
                  </td>
                  <td onClick={(e) => handleScreenNameClick(e, user)} className="pointer">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <div
                        className="medium-avatar"
                        style={user.profile_image ? { width: 36, height: 36, borderRadius: '50%', overflow: 'hidden', display: 'inline-flex', flexShrink: 0 } : getAvatarStyle(user.screen_name)}
                      >
                        {user.profile_image ? (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + user.profile_image}
                            alt={user.screen_name}
                            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                          />
                        ) : getInitials(user.screen_name)}
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div>
                          <span className="screen-name-link" style={{ textTransform: 'capitalize' }} onClick={(e) => handleScreenNameClick(e, user)}>
                            {user.screen_name ? user.screen_name : "N/A"}
                          </span>
                          {(user.comments != null && user.comments !== "") && (<b style={{ fontSize: '22px' }}>*</b>)}
                        </div>
                        <div style={{ fontSize: '12px', color: '#888', textTransform: 'none' }}>
                          {user.email}<CopyComponent value={user.email} />
                        </div>
                      </div>
                    </div>
                  </td>
                  <td><ToggleTestUser
                    clientId={user.id}
                    initialStatus={user.test_user === 1} // Set initial toggle state
                    onStatusChange={(id, newStatus) => {
                      console.log(`Client ${id} status changed to ${newStatus ? 'on' : 'off'}`);
                      // Additional handling if necessary
                    }}/></td>
                  <td>{user.refer_code ? user.refer_code : "-"}</td>
                  {/* <td>{user.number_of_uses}</td> */}
                  <td>
                    {user.created_at ? (
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <span style={{ margin: 0, float: 'none', width: 'auto' }}>{user.created_at.split(' ')[0]}</span>
                        <span style={{ margin: 0, float: 'none', width: 'auto' }}>{user.created_at.split(' ').slice(1).join(' ')}</span>
                      </div>
                    ) : ''}
                  </td>

                  <td>{getMediumRole(user.current_mediumship_level)}</td>
                  <td><FraudSignalBadge client={user} userType="medium" /></td>
                  {/* <td>
                    <Button
                      status={user.resent_status}
                      onClick={(e) => resendUnverifiedEmail(e, user.id)}
                      type="button"
                      className="resend-btn"
                      title="Resend"
                    />
                  </td> */}
                  <td>
                    <button
                      onClick={(e) => handleEditClick(e, user)}
                      style={{ padding: '5px 14px', fontSize: '12px', fontWeight: '600', background: '#d5a67b', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', whiteSpace: 'nowrap' }}
                    >
                      Edit
                    </button>
                  </td>
                  {/* <td className="dot-image dott">
                    <img
                      className="padding-10"
                      onClick={(e) =>
                        onClickHandler(e, user.id, "unverifiedemails")
                      }
                      src="../images/Unionblck.png"
                      alt="dots"
                    />
                    {user.status && (
                      <div className="approve-btn-1 approve-btn z-index-1">
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(
                              user,
                              5,
                              "unverifiedemails",
                              "unverifiedemails"
                            );
                          }}
                        >
                          Approve
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(user, 2, "unverifiedemails", "");
                          }}
                        >
                          Decline
                        </span>

                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            updateUser(user, 3, "delete", "unverifiedemails");
                          }}
                        >
                          Delete
                        </span>
                        <span
                          onClick={(e) => {
                            e.stopPropagation();
                            navigateUser(user);
                          }}
                        >
                          View
                        </span>
                      </div>
                    )}
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} style={{ padding: '48px 0', textAlign: 'center' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="8" r="4" stroke="#d5a67b" strokeWidth="1.5"/>
                      <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="#d5a67b" strokeWidth="1.5" strokeLinecap="round"/>
                      <line x1="8" y1="8" x2="16" y2="8" stroke="none"/>
                    </svg>
                    <p style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#485257' }}>No unverified emails found</p>
                    <p style={{ margin: 0, fontSize: '13px', color: '#aaa' }}>Try adjusting your filters or load all records</p>
                  </div>
                </td>
              </tr>
            )}
            {/* <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr>
          <tr className="innr">
            <td>
              <input type="checkbox" id="two" />
              <label htmlFor="two"></label>
              <img src="../images/davilimg.png" />
              <span>Devid Smith</span>
            </td>
            <td>mariagoncalves.school@gmail.com</td>
            <td className="change">
              <em>Novice</em>
              <a href="#">Change</a>
            </td>
            <td>Practice - 60 Min (30 Min each)</td>
            <td className="dot-image">
              <img src="../images/Unionblck.png" />
            </td>
          </tr> */}
          </tbody>
        </table>
        {/* <div className="pagination-box">
        <div className="left-pagi">
          <span>Showing 1 to 10 of 18 entries</span>
        </div>
        <div className="right-pagi">
          <ul>
            <li>Previous</li>
            <li className="active">
              <a href="#">1</a>
            </li>
            <li>
              <a href="#">2</a>
            </li>
            <li>
              <a href="#">3</a>
            </li>
            <li>Next</li>
          </ul>
        </div>
      </div> */}
        <Pagination rowsPerPageOptions={[25, 50, 100]} count={allUnverifiedEmailsCountMediumPage} activeTab={"unverifiedemails"} unverifiedEmailsPage={unverifiedEmailsPage}
          unverifiedEmailsrowsPerPage={unverifiedEmailsrowsPerPage} getPaginationData={getPaginationData} />
      </div>
      <MediumInfoPanel
        medium={panelMedium}
        details={panelDetails}
        detailsLoading={panelLoading}
        onClose={() => setPanelMedium(null)}
        actions={panelActions}
      />
    </>
  );
}
